export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "bb-themeWrap" */'./ThemeImporter'),
    LiveThemeImporter: () => import(/* webpackChunkName: "bb-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "bb-themeWrap" */'./ThemeImporter'),
    LiveThemeImporter: () => import(/* webpackChunkName: "bb-themeWrapLive" */'./LiveThemeImporter'),
  },
};
